"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletConnectionManagerEvent = exports.WalletConnectionManagerTopicInfoCacheKey = void 0;
exports.WalletConnectionManagerTopicInfoCacheKey = "wcmtic";
exports.WalletConnectionManagerEvent = {
    RECEIVE_REQUEST: "payload"
};
